import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/persona-responsable-del-reino-unido-ukrp")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/persona-responsable-del-reino-unido-ukrp"),
  component: RegulatoryOffering,
});

